import { CONTENT_MODES } from './constants'

export const isEmbedMode = (contentMode) => contentMode === CONTENT_MODES.PREVIEW
